import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { isUserIdentityVerified } from '../../util/identity';

import css from './VerifiedBadge.module.css';

const VerifiedBadge = props => {
  const { user, className, rootClassName } = props;
  const intl = useIntl();
  if (!isUserIdentityVerified(user)) {
    return null;
  }

  return (
    <span
      className={classNames(rootClassName || css.root, className)}
      title={intl.formatMessage({ id: 'VerifiedBadge.title' })}
    >
      <FormattedMessage id="VerifiedBadge.label" />
    </span>
  );
};

export const VerifiedTrustNote = props => {
  const { user, className } = props;
  if (!isUserIdentityVerified(user)) {
    return null;
  }
  return (
    <p className={classNames(css.trustNote, className)} data-verified-trust-note="true">
      <FormattedMessage id="VerifiedBadge.trustNote" />
    </p>
  );
};

export default VerifiedBadge;
